import {CenteredDesign} from "../../../../../components/DesignSystem/CenteredDesign/CenteredDesign";
import {Flex} from "antd";
import {ChatUploadData} from "../chats/ChatUploadData";
import {Spacer} from "../../../../../components/DesignSystem/Spacer/Spacer";
import React from "react";
import {ArticleHeader, ArticleParagraph} from "../../../../../components/DesignSystem/Articles/Articles";


export const ViewPage = ({user}) => {
    return <CenteredDesign>
        <Spacer size={"large"}/>
        <Spacer size={"large"}/>
        <Flex justify={"center"}>
            <ArticleHeader>Analyze Your Data</ArticleHeader>
        </Flex>
        <Flex justify={"center"}>
            <ArticleParagraph>Upload your files to explore, visualize, and uncover insights</ArticleParagraph>
        </Flex>
        <Spacer size={"large"}/>

        <Flex justify={"center"}>
            <ChatUploadData fileUploadLimit={user?.companyPlan?.fileUploadLimit} user={user} type={"file"}/>
        </Flex>
        {/*<AvailableFiles user={user}/>*/
        }
    </CenteredDesign>

};